/* eslint-disable camelcase */

export const ANALYTICS_START = 'start';
export const ANALYTICS_END = 'complete';

export enum AnalyticsEvents {
    HOME = 'lokalbank_web_home',
    PAYMENT = 'lokalbank_web_payment',
    BILLS = 'lokalbank_web_bills',
    EFAKTURA = 'lokalbank_web_efaktura',
    BATCH_EFAKTURA = 'lokalbank_web_batch_efaktura',
    ADDRECURRINGPAYMENT = 'lokalbank-web_recurringpayment',
    AVTALEGIRO = 'lokalbank-web-avtalegiro',
    TRANSFER = 'lokalbank_web_transfer',
    TRANSACTION = 'lokalbank_web_transaction',
    DOWNPAYMENT = 'lokalbank_web_loan_downpayment',
}

export interface DataLayerEvent {
    event: string;
    event_category: string;
    event_action: string;
    event_label?: string;
}

export const trackEvent = (event: AnalyticsEvents, category: string, action?: string, label?: string): void => {
    window?.dataLayer?.push({
        event,
        event_category: category,
        event_action: action,
        event_label: label,
    } as DataLayerEvent);
};

export const trackPageView = (path: string): void => {
    window?.dataLayer?.push({
        event: 'pageview',
        page: {
            path,
        },
    });
};
